let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bkXjA")).then(() => parcelRequire('5zgmS'));